import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuard } from './guard/_guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'goods-issue',
        loadChildren:
          './pages/e-pur/goods-issue/goods-issue.module#GoodsIssueModule'
      },
      {
        path: 'return-goods',
        loadChildren:
          './pages/e-pur/returngoods/returngoods.module#ReturngoodsModule'
      },
      {
        path: 'cancel-goods',
        loadChildren:
          './pages/e-pur/cancleCutoff-goods/cancleCutoff-goods.module#CancleCutoffGoodsModule'
      },
      {
        path: 'edit-delivery',
        loadChildren:
          './pages/e-pur/edit-Delivery/edit-delivery.module#EditDeliveryModule'
      },
      {
        path: 'dashboard',
        loadChildren: './pages/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'user',
        loadChildren: './pages/user/user.module#UserModule'
      },
      {
        path: 'grouppermission',
        loadChildren:
          './pages/group-permission/group-permission.module#GroupPermissionModule'
      },
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'not-authorized',
        loadChildren: './pages/not-authorized/not-authorized.module#NotAuthorizedModule'
      },
      {
        path: 'login',
        loadChildren: './pages/login/login.module#LoginModule'
      },
      {
        path: 'auth',
        loadChildren: './theme/auth/auth.module#AuthModule'
      },
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
